import React from "react";
// import {Router, Route, Routes } from "react-router-dom";
import {Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import GotoTop from './Layout/GotoTop'
import Youtube from "./Pages/Youtube";
import Causes from "./Pages/Causes";
import FAQs from "./Pages/FAQs";
// import ShareMemory from "./Pages/ShareMemory";
// import MessageSlider from "./Pages/MessageSlider";

function App() {
  return (
    <div>
      <GotoTop/>   
        <Routes>          
          <Route exact path='/' element={<Home/>}></Route>
          <Route exact path='/youtube' element={<Youtube/>}></Route>
          <Route exact path='/causes' element={<Causes/>}></Route>
          <Route exact path='/sharememory' element={<Causes/>}></Route>
          <Route exact path='/messageslider' element={<Causes/>}></Route>
          <Route exact path='/faqs' element={<FAQs/>}></Route>          
        </Routes> 
    </div>
  );
}

export default App;
